module.exports = __webpack_public_path__ + "img/slika20.81d288ae.jpg";